<template>
  <div style="background-color: #fff">
    <div class="main">
      <h3 class="newsTitle">{{ info.title }}</h3>
      <p class="littleTitle">{{ info.summary }}</p>
      <p class="newsMsg">
        发布时间：{{ info.time }} <br />
        来源：{{ info.source }} <br />
        编辑：{{ info.examine }}
        <div class="case-tags" v-if="tags.length">
          <span class="tag-item" v-for="tag in tags" :key="tag">{{ tag }}</span>
        </div>
      </p>
      <p v-html="content"></p>
      <!-- 案例详情：上一篇 / 下一篇 -->
      <ul class="case-pager" v-if="showCasePager">
        <li class="case-pager-item" v-if="prevCase">
          <span>上一篇：</span>
          <a href="javascript:;" @click="goAdjacent(prevCase)">{{
            prevCase.title
          }}</a>
        </li>
        <li class="case-pager-item" v-if="nextCase">
          <span>下一篇：</span>
          <a href="javascript:;" @click="goAdjacent(nextCase)">{{
            nextCase.title
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import req from "@/utils/index.js";

const CASE_CID_TO_TYPE = {
  47: "family",
  48: "criminal",
  50: "receivable",
};

export default {
  data() {
    return {
      info: {},
      content: "",
      tags: [],
      caseType: "",
      prevCase: null,
      nextCase: null,
    };
  },
  computed: {
    showCasePager() {
      return !!(this.prevCase || this.nextCase);
    },
  },
  watch: {
    "$route.params.id"(id) {
      if (id) {
        this.loadPage();
      }
    },
  },
  created() {
    this.loadPage();
  },
  methods: {
    splitTags(value) {
      return String(value || "")
        .replace(/&comma;|&#44;/gi, ",")
        .split(/[,，、;；|/／]+/)
        .map((item) => item.trim())
        .filter(Boolean);
    },
    initeData(data) {
      let nodes = data.content;
      const regex = new RegExp("<img", "gi");
      const space = new RegExp("<p>&crarr;</p>", "gi");
      const space1 = new RegExp("section", "gi");
      const space2 = new RegExp("<p", "gi");
      const space3 = new RegExp("↵", "gi");
      nodes = nodes.replace(regex, `<img style="max-width: 100%;"`);
      nodes = nodes.replace(space, "");
      nodes = nodes.replace(space1, "p");
      nodes = nodes.replace(space2, `<p style="margin-top:15px"`);
      nodes = nodes.replace(space3, "");
      this.content = nodes;
    },
    goAdjacent(item) {
      if (!item || !item.id || !this.caseType) return;
      this.$router.push({
        name: "caseDetail",
        params: { type: this.caseType, id: String(item.id) },
      });
      window.scrollTo(0, 0);
    },
    loadCaseAdjacentAndTags(cid, id) {
      this.prevCase = null;
      this.nextCase = null;
      req("post", "api/base/articlelist", {
        Cid: String(cid),
        Page: 1,
        Limit: 500,
      }).then((res) => {
        const rows = res.data || [];
        const index = rows.findIndex(
          (item) => String(item.id) === String(id)
        );
        if (index < 0) return;
        this.prevCase =
          index > 0
            ? { id: rows[index - 1].id, title: rows[index - 1].title }
            : null;
        this.nextCase =
          index < rows.length - 1
            ? { id: rows[index + 1].id, title: rows[index + 1].title }
            : null;
        if (!this.tags.length) {
          const current = rows[index];
          this.tags =
            current && current.fields
              ? this.splitTags(current.fields.field_type)
              : [];
        }
      });
    },
    loadPage() {
      const id = this.$route.params.id || this.$route.query.id;
      this.prevCase = null;
      this.nextCase = null;
      this.tags = [];
      this.caseType = "";
      req("get", "api/base/getcontent?zd=1&id=" + id, {}).then((res) => {
        const cateId =
          (res.info && res.info.cid) || (res.cateInfo && res.cateInfo.id);
        const caseType = CASE_CID_TO_TYPE[Number(cateId)] || "";
        if (caseType && this.$route.name === "newsMsg") {
          this.$router.replace({
            name: "caseDetail",
            params: { type: caseType, id: String(id) },
            query: { tag: this.$route.query.tag },
          });
          return;
        }
        this.caseType = caseType || this.$route.params.type || "";
        this.initeData(res.info);
        if (caseType) {
          const display =
            (res.info.fields &&
              res.info.fields.field_display_time &&
              String(res.info.fields.field_display_time).trim()) ||
            res.info.time ||
            "";
          res.info.time = String(display).substring(0, 10);
        } else {
          res.info.time = res.info.time.substring(0, 10);
        }
        this.info = res.info;
        if (!caseType) {
          return;
        }
        this.tags = this.splitTags(
          res.info.fields && res.info.fields.field_type
        );
        this.loadCaseAdjacentAndTags(cateId, res.info.id);
      });
    },
  },
};
</script>

<style scoped>
.littleTitle {
  color: #999;
}
.main {
  width: 90%;
  margin: 0 auto;
}
.newsMsg {
  font-size: 0.4rem;
  color: #999;
  margin-bottom: 0.4rem;
}
.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.16rem;
  padding-top: 0.36rem;
}
.tag-item {
  color: rgb(77, 89, 105);
  border: none;
  background: rgba(77, 89, 105, 0.1);
  border-radius: 0.36rem;
  font-size: 0.26rem;
  font-weight: 700;
  line-height: 0.56rem;
  padding: 0 0.24rem;
}
.case-pager {
  list-style: none;
  margin: 0.6rem 0 1.2rem;
  padding: 0.4rem 0 0.6rem;
  border-top: 1px solid #f0f0f0;
}
.case-pager-item {
  width: 100%;
  font-size: 0.28rem;
  line-height: 0.48rem;
  color: #888;
  margin-bottom: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.case-pager-item a {
  color: #999;
  text-decoration: none;
}
.paragraph {
  color: #666666;
  font-size: 0.3rem;
}
.imgCss {
  width: 100%;
}
</style>
